import { render, staticRenderFns } from "./PrivacyForm.vue?vue&type=template&id=01257745&scoped=true"
import script from "./PrivacyForm.vue?vue&type=script&lang=js"
export * from "./PrivacyForm.vue?vue&type=script&lang=js"
import style0 from "./PrivacyForm.vue?vue&type=style&index=0&id=01257745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01257745",
  null
  
)

export default component.exports